import { My } from '../My';

const WITHDRAWN_PREFIX = '[Withdrawn]';
const UNKNOWN_USER = 'Unknown User';
const UNKNOWN = 'Unknown';

const translations: Record<string, { withdrawn: string; unknownUser: string; unknown: string }> = {
    ko: { withdrawn: '[탈퇴]', unknownUser: '알 수 없는 유저', unknown: '알 수 없음' },
    ja: { withdrawn: '[退会]', unknownUser: '不明なユーザー', unknown: '不明' },
    en: { withdrawn: '[Withdrawn]', unknownUser: 'Unknown User', unknown: 'Unknown' },
};

function getTranslation(lang?: string) {
    return translations[lang || 'en'] || translations['en'];
}

/**
 * 서버에서 영어 마커로 저장된 탈퇴 유저 이름을 현재 사용자 언어로 변환합니다.
 *
 * - `[Withdrawn] 홍길동` → `[탈퇴] 홍길동` (ko)
 * - `[Withdrawn] Unknown User` → `[退会] 不明なユーザー` (ja)
 * - `Unknown` → `알 수 없음` (ko)
 */
export function getDisplayName(user: { name?: string; email?: string | null }): string {
    const name = user.name || '';
    const lang = My.user?.lang;
    const t = getTranslation(lang);

    if (name.startsWith(WITHDRAWN_PREFIX)) {
        const rest = name.slice(WITHDRAWN_PREFIX.length).trim();
        const localizedRest = rest === UNKNOWN_USER ? t.unknownUser : rest;
        return `${t.withdrawn} ${localizedRest}`;
    }

    if (name === UNKNOWN) {
        return t.unknown;
    }

    return name;
}

/**
 * 메시지의 유저정보를 Room.users에서 찾아 최신 정보로 오버라이드합니다.
 * - Room에 있는 유저 → Room.users의 최신 유저정보 반환
 * - Room에 없는 유저(나간 유저) → 메시지에 저장된 유저정보 그대로 반환
 */
export function resolveMessageUser<T extends { id: string }>(
    msgUser: T,
    roomUsers?: { id: string }[]
): T {
    if (!roomUsers) return msgUser;
    const found = roomUsers.find(u => u.id === msgUser.id);
    return (found as T) ?? msgUser;
}
